module.exports = __webpack_public_path__ + "img/1-210604104Z5210.02ed933f.png";